import { Slider } from "@mui/material";
import { blackColor, lightVioletColor, violetColor } from "../constants/colors";

const RangeSlider = ({ value, onChange, min, max, step, marks }) => {
  return (
    <Slider
      sx={{
        width: "100%",
        height: "31px",
        color: "#6e5ab4",
        "& .MuiSlider-thumb": {
          width: "8px",
          height: "46px",
          borderRadius: "0px",
          backgroundColor: violetColor,
          boxShadow: "none",
        },
        "& .MuiSlider-rail": {
          borderRadius: "0px",
          backgroundColor: "#ffffff",
          borderColor: blackColor,
          borderStyle: "solid",
          borderWidth: "1px",
          opacity: 1,
        },
        "& .MuiSlider-track": {
          borderRadius: "0px",
          backgroundColor: lightVioletColor,
        },
      }}
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      marks={marks}
    />
  );
};

export default RangeSlider;
